import { Component, OnInit, NgZone, type ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {
  DatatableComponent,
  DatatableRowDetailDirective,
} from '@swimlane/ngx-datatable';
import { SettingsService } from '../../settings/settings.service';

@Component({
  selector: 'app-supplier-service-rfq-list',
  templateUrl: './supplier-service-rfq-list.component.html',
  styleUrls: ['./supplier-service-rfq-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplierServiceRfqListComponent implements OnInit {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  @ViewChild('myDetailRow') table!: DatatableComponent;
  @ViewChild('myDetailRow', { static: false })
  rowDetail!: DatatableRowDetailDirective;
  menuTrigger: MatMenuTrigger | null = null;

  showLoader: boolean = false;
  searchKeyword: string = '';

  limit: number = 10;
  offset: number = 0;
  archivedLimit: number = 10;
  archivedOffset: number = 0;
  totalRecords: number = 0;
  archivedTotalRecords: number = 0;
  sortField: string = 'serviceRfqDate';
  sortDirection: string = 'desc';
  docStatus: string = '';
  fromDate: any;
  toDate: any;
  archivedLoaded: boolean = false;

  allDocumentData: any[] = [];
  documentData: any[] = [];
  archivedDocumentData: any[] = [];
  documentDataTotalRecords: number = 0;
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedRfqDetails: number[] = [];
  selectedArchivedRfq: number[] = [];
  selectedArchivedRfqDetails: number[] = [];
  selectedStatus: string[] = ['ALL'];

  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Received:' },
    { name: 'Acknowledged', heading: 'RFQ Acknowledged:' },
    { name: 'Declined', heading: 'RFQ Declined:' },
    { name: 'Lost', heading: 'RFQ Lost:' },
    { name: 'Lapsed', heading: 'RFQ Lapsed:' },
    { name: 'Submitted', heading: 'RFQ Submitted:' },
    { name: 'Draft', heading: 'RFQ Drafted:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Received' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },
    { name: 'Quoted', heading: 'Quotation Submitted' },
    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
  ];

  filterStatuses = [
    { name: 'Acknowledged', label: 'RFQ' },
    { name: 'Declined', label: 'RFQ' },
    { name: 'Lost', label: 'RFQ' },
    { name: 'Lapsed', label: 'RFQ' },
    { name: 'Unactioned', label: 'RFQ' },
    { name: 'ALL', label: 'RFQ' },
  ];

  activeIndex: number = this.filterStatuses.length - 1;
  activeIndexes: number[] = [this.filterStatuses.length - 1];

  statusColors: { [key: string]: string } = {
    Acknowledged: '#00B3B3',
    Declined: '#FF0000',
    Lost: '#FF0000',
    Lapsed: '#FF8A00',
    Unactioned: '#727272',
  };

  supplierUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;

  headerData: any;
  isChatOpen: boolean = false;
  userRole!: string;
  userId!: number;
  newMessage = '';
  messages: { sender: string; message: string; time: string }[] = [];
  showChatHistoryButton: boolean = false;
  rfqId!: number;

  otherStatus = [
    { name: 'Accepted', label: 'Quote' },
    { name: 'Declined', label: 'Quote' },
    { name: 'Draft', label: 'Quote' },
    { name: 'Quoted', label: 'Quote' },
    { name: 'Withdrawn', label: 'Quote' },
  ];

  dropdownOpen: boolean = false;
  rfqTypeDropdownOpen: boolean = false;

  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup: boolean = false;
  selectedBuyer: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax: 'N/A',
  };

  items = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel', prop: 'vesselName', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'assignedUsers', selected: false },
  ];

  archivedItems = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel', prop: 'vesselName', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'assignedUsers', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  expandedQuoteId: number | null = null;

  // Stable row identity for ngx-datatable to reduce DOM churn
  rowIdentity = (row: any) => row?.serviceRfqId ?? row?.id;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
  }

  ngOnInit() {
    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');

    if (this.userRole === 'Suppliers') {
      this.showChatHistoryButton = true;
    }

    // Load data from API
    this.loadData();
  }

  async loadData() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const fromDateFormatted = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : null;
      const toDateFormatted = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : null;

      const response = await this.settingsService.fetchAllServiceRfqBySupplierId(
        this.searchParam,
        this.userId,
        this.docStatus,
        fromDateFormatted,
        toDateFormatted,
        this.sortField,
        this.sortDirection,
        this.limit,
        this.offset,
        1 // isActive = 1 for active records
      );

      if (response && response.rows) {
        // Map the response data to include additional UI properties
        this.documentData = response.rows.map((row: any) => this.mapRowData(row));
        this.totalRecords = response.totalElements || 0;

        // Auto-expand first row
        if (this.documentData.length > 0) {
          const first = this.documentData[0];
          this.expandedQuoteId = first.id;
          first.statusesStages = this.buildRfqStages(first);
          first.statusesStages = this.buildOtherStages(first);
        }
      } else {
        this.documentData = [];
        this.totalRecords = 0;
      }
    } catch (error) {
      console.error('Error loading service RFQ data:', error);
      this.snack.open('Error loading data. Please try again.', 'OK', { duration: 3000 });
      this.documentData = [];
      this.totalRecords = 0;
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async loadArchivedData() {
    try {
      const fromDateFormatted = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : null;
      const toDateFormatted = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : null;

      const response = await this.settingsService.fetchAllServiceRfqBySupplierId(
        this.searchParam,
        this.userId,
        this.docStatus,
        fromDateFormatted,
        toDateFormatted,
        this.sortField,
        this.sortDirection,
        this.archivedLimit,
        this.archivedOffset,
        0 // isActive = 0 for archived records
      );

      if (response && response.rows) {
        this.archivedDocumentData = response.rows.map((row: any) => this.mapRowData(row));
        this.archivedTotalRecords = response.totalElements || 0;
      } else {
        this.archivedDocumentData = [];
        this.archivedTotalRecords = 0;
      }
    } catch (error) {
      console.error('Error loading archived service RFQ data:', error);
      this.archivedDocumentData = [];
      this.archivedTotalRecords = 0;
    } finally {
      this.cdr.markForCheck();
    }
  }

  mapRowData(row: any): any {
    // Calculate remaining time
    const remaining = this.calculateRemainingTime(row.quotedByDate);

    return {
      ...row,
      id: row.serviceRfqId || row.id,
      serviceRfqId: row.serviceRfqId || row.id,
      serviceRfqDetailsId: row.rfqDetailsId || row.serviceRfqId,
      supplierRfqDetailsId: row.supplierServiceRfqDetailsId,
      serviceRfqRefNumber: row.rfqRefNumber,
      serviceRfqDate: row.rfqDate,
      serviceRfqDateFormatted: row.rfqDate ? moment(row.rfqDate).format('DD/MM/YYYY') : '',
      statusColor: this.getStatusColor(row.docStatus),
      remaining: remaining,
      remainingQuote: remaining,
      buyerAttachments: row.buyerAttachments || [],
      lineItemAttachments: row.lineItemAttachments || [],
      rfqStatusStages: row.rfqStatusStages || [],
      statusesStages: null,
    };
  }

  calculateRemainingTime(quotedByDate: any): { label: string; color: string; tooltip: string } {
    if (!quotedByDate) {
      return { label: '', color: '#000000', tooltip: '' };
    }

    const now = moment();
    const dueDate = moment(quotedByDate);
    const diffDays = dueDate.diff(now, 'days');

    if (diffDays < 0) {
      return { label: 'Overdue', color: '#000000', tooltip: `Overdue by ${Math.abs(diffDays)} days` };
    } else if (diffDays <= 3) {
      return { label: 'Urgent', color: '#F60303', tooltip: `Due in ${diffDays} days` };
    } else if (diffDays <= 7) {
      return { label: 'Standard', color: '#FD8900', tooltip: `Due in ${diffDays} days` };
    } else {
      return { label: 'New', color: '#0BA716', tooltip: `Due in ${diffDays} days` };
    }
  }

  get userIdAsString(): string {
    return this.userId.toString();
  }

  // Status color getter
  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000';
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment();
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    if (diffInSeconds < 60) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (${diffInSeconds} seconds ago)`;
    } else if (diffInMinutes < 60) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (${diffInMinutes} minutes ago)`;
    } else if (diffInHours < 24) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (${diffInHours} hours ago)`;
    } else if (diffInDays === 1) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (Yesterday)`;
    } else {
      return moment(rfqDate).format('DD MMM YYYY');
    }
  }

  onStatusSelect(status: string, index: number, label: string) {
    this.activeIndex = index;
    if (label === 'RFQ') {
      if (this.selectedStatus.includes(status)) {
        return;
      }
      if (status !== 'ALL') {
        this.docStatus = status;
      } else {
        this.docStatus = '';
      }
      this.selectedStatus = [status];
      this.activeIndexes = [index];
      this.expandedQuoteId = null;
      this.offset = 0;
      this.loadData();
    } else if (label === 'Quote') {
      // Navigate to service quote list when implemented
      this.snack.open('Service Quote List - Coming Soon', 'OK', { duration: 2000 });
    }
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateArchivedSelectedColumns();
  }

  updateSelectedColumns() {
    this.selectedColumns = this.items
      .filter((item) => item.selected)
      .map((item) => ({ label: item.label, prop: item.prop }));
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected)
      .map((item) => ({ label: item.label, prop: item.prop }));
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  onPageChange(event: any) {
    this.offset = event.offset;
    this.selectedRfq = [];
    this.loadData();
  }

  onSearch() {
    this.offset = 0;
    this.archivedOffset = 0;
    this.loadData();
    if (this.archivedLoaded) {
      this.loadArchivedData();
    }
  }

  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.offset = 0;
    this.loadData();
    if (this.archivedLoaded) {
      this.archivedOffset = 0;
      this.loadArchivedData();
    }
  }

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset;
    this.loadArchivedData();
  }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand) {
      if (!this.archivedLoaded) {
        this.archivedLoaded = true;
        this.loadArchivedData();
      }
      if (this.heading) {
        this.heading.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }

  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = ['ALL'];
    this.docStatus = '';
    this.searchParam = '';
    this.loadData();
    if (this.archivedLoaded) {
      this.loadArchivedData();
    }
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    const ids = this.documentData.map((item) => item.serviceRfqId);

    if (section === 'active') {
      if (checked) {
        this.selectedRfq = this.documentData.map((item) => item.serviceRfqId);
        this.selectedRfqDetails = this.documentData.map((item) => item.supplierRfqDetailsId);
      } else {
        this.selectedRfq = [];
        this.selectedRfqDetails = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq = this.archivedDocumentData.map((item) => item.serviceRfqId);
        this.selectedArchivedRfqDetails = this.archivedDocumentData.map((item) => item.supplierRfqDetailsId);
      } else {
        this.selectedArchivedRfq = [];
        this.selectedArchivedRfqDetails = [];
      }
    }
  }

  selectDeselectRfq(event: any, supplierRfqDetailsId: any, rfqId: any, section: string, assignedUsers: any) {
    const checked = event.target.checked;

    if (section === 'active') {
      if (checked) {
        this.selectedRfq.push(rfqId);
        this.selectedRfqDetails.push(supplierRfqDetailsId);
        // Only show message if there are actually assigned users (not null, undefined, or empty string)
        if (assignedUsers && assignedUsers.trim() !== '') {
          this.snack.open(`Note: Service RFQ ${rfqId} already has assigned user(s): ${assignedUsers}`, 'OK', {
            duration: 5000,
          });
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter((id) => id !== rfqId);
        this.selectedRfqDetails = this.selectedRfqDetails.filter((id) => id !== supplierRfqDetailsId);
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(rfqId);
        this.selectedArchivedRfqDetails.push(supplierRfqDetailsId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter((id) => id !== rfqId);
        this.selectedArchivedRfqDetails = this.selectedArchivedRfqDetails.filter((id) => id !== supplierRfqDetailsId);
      }
    }
  }

  isChecked(rfqId: number, section: string) {
    if (section === 'active') {
      return this.selectedRfq.includes(rfqId);
    } else {
      return this.selectedArchivedRfq.includes(rfqId);
    }
  }

  openRfqDetails(serviceRfqId: number) {
    this.router.navigate(['/dashboard', 'quote', 'service-rfq-details', serviceRfqId]);
  }

  toggleExpandedRow(row: any) {
    this.expandedQuoteId = this.expandedQuoteId === row.id ? null : row.id;
    if (this.expandedQuoteId === row.id && !row.statusesStages) {
      row.statusesStages = this.buildRfqStages(row);
      row.statusesStages = this.buildOtherStages(row);
    }
  }

  buildRfqStages(rfq: any) {
    const stagesArray: any[] = [];

    // Build basic stages based on docStatus
    stagesArray.push({
      heading: 'RFQ Received:',
      label: 'RFQ Received',
      date: this.formatDate(rfq.serviceRfqDate),
      completed: true,
    });

    if (rfq.docStatus === 'Acknowledged') {
      stagesArray.push({
        heading: 'RFQ Acknowledged:',
        label: 'RFQ Acknowledged',
        date: this.formatDate(new Date()),
        completed: true,
      });
    } else if (rfq.docStatus === 'Declined') {
      stagesArray.push({
        heading: 'RFQ Declined:',
        label: 'RFQ Declined',
        date: this.formatDate(new Date()),
        completed: true,
      });
    } else if (rfq.docStatus === 'Lapsed') {
      stagesArray.push({
        heading: 'RFQ Lapsed:',
        label: 'RFQ Lapsed',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    } else if (rfq.docStatus === 'Lost') {
      stagesArray.push({
        heading: 'RFQ Lost:',
        label: 'RFQ Lost',
        date: this.formatDate(new Date()),
        completed: true,
      });
    } else {
      // Unactioned - show pending acknowledge
      stagesArray.push({
        heading: 'RFQ Acknowledged:',
        label: 'RFQ Acknowledged',
        date: '',
        completed: false,
      });
    }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];

    stagesArray.push({
      heading: 'Quotation Submitted',
      label: 'Quoted',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'PO Confirmation',
      label: 'PO Confirmation',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'Delivered Onboard',
      label: 'Delivered',
      date: '',
      completed: false,
    });

    return stagesArray;
  }

  formatDate(date: string | Date): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-GB');
  }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Declined') {
      return 'stage-declined';
    }
    switch (label) {
      case 'RFQ Declined':
        return 'stage-declined';
      case 'RFQ Lapsed':
        return 'stage-lapsed';
      default:
        return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  // User Assignment Methods
  async toggleUserSelection(user: any) {
    if (this.selectedRfq.length === 0) {
      this.snack.open('Please select at least one Service RFQ before selecting a user.', 'OK', {
        duration: 3000,
      });
      return;
    }

    user.selected = !user.selected;

    if (user.selected) {
      // Assign user to selected RFQs
      await this.assignUserToSelectedRfqs(user);
    } else {
      // Unassign user from selected RFQs
      await this.unassignUserFromSelectedRfqs(user);
    }
  }

  async assignUserToSelectedRfqs(user: any) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      // Assign to each selected RFQ
      for (const serviceRfqId of this.selectedRfq) {
        await this.settingsService.assignUserToServiceRfq(
          serviceRfqId,
          user.id,
          this.userId
        );
      }

      this.snack.open(`User ${user.firstName} ${user.lastName} assigned to ${this.selectedRfq.length} RFQ(s).`, 'OK', { duration: 3000 });

      // Reload data to show updated assignments
      await this.loadData();

      // Clear selection
      this.selectedRfq = [];
      this.selectedRfqDetails = [];
    } catch (error) {
      console.error('Error assigning user:', error);
      this.snack.open('Error assigning user. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async unassignUserFromSelectedRfqs(user: any) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      for (const serviceRfqId of this.selectedRfq) {
        await this.settingsService.unassignUserFromServiceRfq(
          serviceRfqId,
          user.id
        );
      }

      this.snack.open(`User ${user.firstName} ${user.lastName} unassigned from ${this.selectedRfq.length} RFQ(s).`, 'OK', { duration: 3000 });

      await this.loadData();

      this.selectedRfq = [];
      this.selectedRfqDetails = [];
    } catch (error) {
      console.error('Error unassigning user:', error);
      this.snack.open('Error unassigning user. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async bulkAssignUsers() {
    if (this.selectedRfq.length === 0) {
      this.snack.open('Please select at least one Service RFQ.', 'OK', { duration: 3000 });
      return;
    }

    const selectedUserIds = this.supplierUsersList
      .filter((u: any) => u.selected)
      .map((u: any) => u.id)
      .join(',');

    if (!selectedUserIds) {
      this.snack.open('Please select at least one user to assign.', 'OK', { duration: 3000 });
      return;
    }

    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      for (const serviceRfqId of this.selectedRfq) {
        await this.settingsService.bulkAssignUsersToServiceRfq(
          serviceRfqId,
          selectedUserIds,
          this.userId
        );
      }

      this.snack.open('Users assigned successfully.', 'OK', { duration: 3000 });
      await this.loadData();

      this.selectedRfq = [];
      this.selectedRfqDetails = [];
      this.supplierUsersList.forEach((u: any) => u.selected = false);
    } catch (error) {
      console.error('Error bulk assigning users:', error);
      this.snack.open('Error assigning users. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  onScroll(): void {
    // Pagination scroll handler for loading more users
  }

  onUserMenuOpened() {
    // Load supplier users from API
    this.settingsService.fetchUserBySupplierId(
      this.userId,
      this.userlimit,
      this.useroffset
    ).subscribe({
      next: (response) => {
        if (response && response.rows) {
          this.supplierUsersList = response.rows.map((user: any) => ({
            ...user,
            selected: false
          }));
        }
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error loading supplier users:', error);
        this.supplierUsersList = [];
        this.cdr.markForCheck();
      }
    });
  }

  openChat(rfq: any) {
    this.snack.open('Chat functionality - Coming Soon', 'OK', { duration: 2000 });
  }

  closeChat() {
    this.isChatOpen = false;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  toggleRfqTypeDropdown() {
    this.rfqTypeDropdownOpen = !this.rfqTypeDropdownOpen;
  }

  navigateToRfqType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/supplier-rfq-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/supplier-service-rfq-list']);
    }
  }

  togglePreview(value: boolean, row?: any) {
    this.previewSection = value;
    this.previewDocs = [];
    if (row) {
      this.previewDocs = [...(row.buyerAttachments || []), ...(row.lineItemAttachments || [])];
    }
  }

  toggleContactPopUp(value: boolean, row?: any) {
    this.showContactPopup = value;
    if (value && row) {
      this.selectedBuyer = {
        companyName: row.buyerCompanyName,
        contactPerson: row.buyerContact,
        email: row.companyEmailId,
        phone: row.buyerCompanyPhoneNumber,
        address: row.buyerCompanyAddress,
        fax: row.buyerCompanyFax,
      };
    }
  }

  async downloadRfq(rfqDetailsId: number, supplierId: number, refNo: string) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const fileName = refNo + '.pdf';

      const pdf = await this.settingsService.generateSupplierServiceRfqAttachment(
        rfqDetailsId,
        supplierId
      );

      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      // Create a temporary <a> element to trigger download
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.snack.open('PDF downloaded successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error downloading Service RFQ PDF:', error);
      this.snack.open('Error downloading PDF. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async generateRFQExcelForSupplier(rfqId: number, supplierId: number, refNo: string) {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const result = await this.settingsService.fetchServiceRfqDetailsForExcel(
        rfqId,
        supplierId
      );

      if (!result || !result.rfqData || result.rfqData.length === 0) {
        this.snack.open('No data found for this Service RFQ.', 'OK', { duration: 3000 });
        return;
      }

      const fileName = refNo + '.xlsx';

      const labelMap: { [key: string]: string } = {
        name: 'Name',
        address: 'Address',
        contact: 'Contact',
        phone: 'Phone',
        email: 'Email',
        mpsBuyerCode: 'MPS Buyer Code',
        mpsSupplierCode: 'MPS Supplier Code',
        PIC: 'PIC',
        fax: 'Fax',
        portName: 'Port Name',
        vesselETA: 'Vessel ETA',
        vesselETD: 'Vessel ETD',
      };

      const rfqData = result.rfqData[0];
      const lineItemData = result.lineItemData || [];

      // Helper to format ISO date strings to DD/MM/YYYY
      const formatDate = (val: any) => {
        if (!val) return '';
        const d = moment(val);
        return d.isValid() ? d.format('DD/MM/YYYY') : '';
      };

      const data = {
        rfqRef: rfqData.serviceRfqRefNumber || '',
        rfqDate: formatDate(rfqData.serviceRfqDate),
        preferredCurrency: rfqData.currencyCode || '',
        vesselName: rfqData.vesselName || '',
        imoNumber: rfqData.vesselImoNumber || '',
        quoteByDate: formatDate(rfqData.quoteByDate),
        requestedDeliveryDate: formatDate(rfqData.requestedDeliveryDate),
        buyerDetails: {
          name: rfqData.buyerCompanyName || '',
          address: rfqData.buyerAddress || '',
          contact: rfqData.buyerContact || '',
          phone: rfqData.buyerPhone || '',
          email: rfqData.buyerEmail || '',
        },
        supplierDetails: {
          name: rfqData.supplierCompanyName || '',
          address: rfqData.supplierAddress || '',
          contact: rfqData.supplierName || '',
          phone: rfqData.supplierPhone || '',
          email: rfqData.supplierEmail || '',
        },
        freightForwarderDetails: {
          PIC: rfqData.freightForwarderPic || '',
          phone: rfqData.freightForwarderPhone || '',
          fax: rfqData.freightForwarderFax || '',
          email: rfqData.freightForwarderEmail || '',
          address: rfqData.freightForwarderAddress || '',
        },
        portAgentDetails: {
          name: rfqData.portAgentName || '',
          phone: rfqData.portAgentPhone || '',
          fax: rfqData.portAgentFax || '',
          email: rfqData.portAgentEmail || '',
          contact: rfqData.portAgentContact || '',
        },
        portDetails: {
          portName: rfqData.portName || '',
          vesselETA: formatDate(rfqData.vesselEta),
          vesselETD: formatDate(rfqData.vesselEtd),
        },
        lineItems: lineItemData.map((item: any, index: number) => ({
          srNo: index + 1,
          serviceCode: item.serviceCode || item.serviceName || '',
          serviceDescription: item.serviceDescription || '',
          qty: item.quantity || '',
          uom: item.uom || '',
          buyerComments: item.buyerComments || '',
        })),
      };

      // Dynamic import to avoid adding exceljs to initial bundle
      const Excel = await import('exceljs');
      const fileSaverMod = await import('file-saver');
      const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
      const workbook = new Excel.Workbook();
      const ws = workbook.addWorksheet('Service RFQ');

      // === TITLE ===
      ws.mergeCells('A1:G1');
      const title = ws.getCell('A1');
      title.value = 'Service Request For Quotation';
      title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
      title.alignment = { horizontal: 'center', vertical: 'middle' };
      ws.addRow([]);

      // === RFQ DETAILS HEADER ===
      const rfqHeader = ws.addRow(['SERVICE RFQ DETAILS']);
      rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
      rfqHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      // RFQ Info
      const rfqInfo = [
        ['RFQ Ref:', data.rfqRef, '', '', '', 'RFQ Date:', data.rfqDate],
        ['Preferred Currency:', data.preferredCurrency, '', '', '', 'Vessel Name:', data.vesselName],
        ['IMO Number:', data.imoNumber, '', '', '', 'Quote By Date:', data.quoteByDate],
        ['Requested Delivery Date:', data.requestedDeliveryDate],
      ];
      rfqInfo.forEach((r) => {
        const row = ws.addRow(r);
        row.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
      });
      ws.addRow([]);

      // === BUYER + SUPPLIER ===
      const bsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
      bsHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
      });
      ws.addRow([]);

      const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const supplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const maxLen = Math.max(buyerEntries.length, supplierEntries.length);
      for (let i = 0; i < maxLen; i++) {
        const b = buyerEntries[i] || ['', ''];
        const s = supplierEntries[i] || ['', ''];
        ws.addRow([b[0], b[1], '', s[0], s[1]]);
      }
      ws.addRow([]);

      // === FREIGHT FORWARDER + PORT AGENT ===
      const ffHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
      ffHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
      });
      ws.addRow([]);

      const ffEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const paEntries = Object.entries(data.portAgentDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);

      const maxLen2 = Math.max(ffEntries.length, paEntries.length);
      for (let i = 0; i < maxLen2; i++) {
        const f = ffEntries[i] || ['', ''];
        const p = paEntries[i] || ['', ''];
        ws.addRow([f[0], f[1], '', p[0], p[1]]);
      }
      ws.addRow([]);

      // === PORT DETAILS ===
      const portHeader = ws.addRow(['Port Details']);
      portHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
      portHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const portEntries = Object.entries(data.portDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()),
        value,
      ]);
      portEntries.forEach((e) => ws.addRow(e));
      ws.addRow([]);

      // === LINE ITEMS ===
      const lineHeader = ws.addRow(['SERVICE LINE ITEMS']);
      lineHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DDEBF7' } };
      lineHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      // Add header row for line items
      const itemHeader = ws.addRow(['Sr.No', 'Service Code', 'Service Description', 'Qty', 'UOM', 'Buyer Comments']);
      itemHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
        c.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });

      // Add line item rows
      data.lineItems.forEach((item: any) => {
        const row = ws.addRow([
          item.srNo,
          item.serviceCode,
          item.serviceDescription,
          item.qty,
          item.uom,
          item.buyerComments,
        ]);
        row.eachCell((c: any) => {
          c.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      });

      // Set column widths
      ws.columns = [
        { width: 20 },
        { width: 25 },
        { width: 35 },
        { width: 10 },
        { width: 10 },
        { width: 30 },
        { width: 20 },
      ];

      // Generate and download the file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);

      this.snack.open('Excel downloaded successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error generating Service RFQ Excel:', error);
      this.snack.open('Error generating Excel. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  generateTemplate(rfqDetailsId: number, docStatus: string, refNo: string) {
    this.snack.open(`Generating template for Service RFQ: ${refNo}`, 'OK', { duration: 2000 });
  }

  onFileChange(evt: any) {
    this.snack.open('Import quote - Coming Soon', 'OK', { duration: 2000 });
  }

  async downloadDocumentDataExcel() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      // Dynamically import XLSX to avoid adding it to initial bundle
      const XLSX = await import('xlsx');

      // Fetch all data without pagination for export
      const allData = await this.fetchAllServiceRfqsForExport();

      if (!allData || allData.length === 0) {
        this.snack.open('No data to export.', 'OK', { duration: 3000 });
        return;
      }

      // Format data for Excel
      const formattedData: any[] = [];
      allData.forEach((document: any) => {
        formattedData.push({
          'Reference': document.rfqRefNumber || '',
          'Vessel': document.vesselName || '',
          'Port Name': document.portName || '',
          'Buyer': document.companyName || '',
          'Status': document.docStatus || '',
          'RFQ Date': document.rfqDate ? moment(document.rfqDate).format('DD/MM/YYYY') : '',
          'Quote By Date': document.quotedByDate ? moment(document.quotedByDate).format('DD/MM/YYYY') : '',
          'Request Delivery Date': document.requestDeliveryDate ? moment(document.requestDeliveryDate).format('DD/MM/YYYY') : '',
          'Vessel ETA': document.vesselEta ? moment(document.vesselEta).format('DD/MM/YYYY') : '',
          'Vessel ETD': document.vesselEtd ? moment(document.vesselEtd).format('DD/MM/YYYY') : '',
          'Owner': document.supplierName || '',
        });
      });

      // Create worksheet and workbook
      const ws: any = XLSX.utils.json_to_sheet(formattedData);
      const wb: any = XLSX.utils.book_new();

      // Set column widths
      ws['!cols'] = [
        { wch: 20 }, // Reference
        { wch: 20 }, // Vessel
        { wch: 15 }, // Port Name
        { wch: 25 }, // Buyer
        { wch: 15 }, // Status
        { wch: 12 }, // RFQ Date
        { wch: 15 }, // Quote By Date
        { wch: 20 }, // Request Delivery Date
        { wch: 12 }, // Vessel ETA
        { wch: 12 }, // Vessel ETD
        { wch: 20 }, // Owner
      ];

      // Append worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Service RFQ Data');

      // Generate filename with current date
      const fileName = `Service_RFQ_Export_${moment().format('YYYY-MM-DD')}.xlsx`;

      // Download the file
      XLSX.writeFile(wb, fileName);

      this.snack.open('Export completed successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error exporting Service RFQ data:', error);
      this.snack.open('Error exporting data. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async fetchAllServiceRfqsForExport(): Promise<any[]> {
    try {
      const fromDateFormatted = this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : null;
      const toDateFormatted = this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : null;

      const response = await this.settingsService.exportAllServiceRfq(
        this.searchParam,
        this.userId,
        this.docStatus,
        fromDateFormatted,
        toDateFormatted,
        1 // isActive = 1 for active records
      );

      if (response && response.rows) {
        return response.rows.map((row: any) => this.mapRowData(row));
      }
      return [];
    } catch (error) {
      console.error('Error fetching Service RFQ data for export:', error);
      return [];
    }
  }

  async rfqOperation(operation: string) {
    if (operation === 'archive') {
      if (this.selectedRfqDetails.length === 0) {
        this.snack.open('Please select at least one Service RFQ.', 'OK', { duration: 3000 });
        return;
      }
      await this.archiveSelectedRfqs();
    } else if (operation === 'unarchive') {
      if (this.selectedArchivedRfqDetails.length === 0) {
        this.snack.open('Please select at least one archived Service RFQ.', 'OK', { duration: 3000 });
        return;
      }
      await this.unArchiveSelectedRfqs();
    }
  }

  async archiveSelectedRfqs() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const response = await this.settingsService.bulkArchiveServiceRfq(
        this.selectedRfqDetails,
        this.userId
      );

      if (response && response.success) {
        this.snack.open(`${this.selectedRfqDetails.length} Service RFQ(s) archived successfully.`, 'OK', { duration: 3000 });
        this.selectedRfq = [];
        this.selectedRfqDetails = [];
        await this.loadData();
        if (this.archivedLoaded) {
          await this.loadArchivedData();
        }
      } else {
        this.snack.open('Failed to archive Service RFQs.', 'OK', { duration: 3000 });
      }
    } catch (error) {
      console.error('Error archiving Service RFQs:', error);
      this.snack.open('Error archiving Service RFQs. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async unArchiveSelectedRfqs() {
    this.showLoader = true;
    this.cdr.markForCheck();

    try {
      const response = await this.settingsService.bulkUnArchiveServiceRfq(
        this.selectedArchivedRfqDetails,
        this.userId
      );

      if (response && response.success) {
        this.snack.open(`${this.selectedArchivedRfqDetails.length} Service RFQ(s) restored successfully.`, 'OK', { duration: 3000 });
        this.selectedArchivedRfq = [];
        this.selectedArchivedRfqDetails = [];
        await this.loadData();
        await this.loadArchivedData();
      } else {
        this.snack.open('Failed to restore Service RFQs.', 'OK', { duration: 3000 });
      }
    } catch (error) {
      console.error('Error restoring Service RFQs:', error);
      this.snack.open('Error restoring Service RFQs. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async RestoreRfq(isConfirmed: boolean, row: any) {
    if (isConfirmed && row && row.supplierRfqDetailsId) {
      this.showLoader = true;
      this.cdr.markForCheck();

      try {
        const response = await this.settingsService.unArchiveServiceRfq(
          row.supplierRfqDetailsId,
          this.userId
        );

        if (response && response.success) {
          this.snack.open('Service RFQ restored successfully.', 'OK', { duration: 3000 });
          await this.loadData();
          await this.loadArchivedData();
        } else {
          this.snack.open('Failed to restore Service RFQ.', 'OK', { duration: 3000 });
        }
      } catch (error) {
        console.error('Error restoring Service RFQ:', error);
        this.snack.open('Error restoring Service RFQ. Please try again.', 'OK', { duration: 3000 });
      } finally {
        this.showLoader = false;
        this.cdr.markForCheck();
      }
    }
  }

  async archiveSingleRfq(row: any) {
    if (row && row.supplierRfqDetailsId) {
      this.showLoader = true;
      this.cdr.markForCheck();

      try {
        const response = await this.settingsService.archiveServiceRfq(
          row.supplierRfqDetailsId,
          this.userId
        );

        if (response && response.success) {
          this.snack.open('Service RFQ archived successfully.', 'OK', { duration: 3000 });
          await this.loadData();
          if (this.archivedLoaded) {
            await this.loadArchivedData();
          }
        } else {
          this.snack.open('Failed to archive Service RFQ.', 'OK', { duration: 3000 });
        }
      } catch (error) {
        console.error('Error archiving Service RFQ:', error);
        this.snack.open('Error archiving Service RFQ. Please try again.', 'OK', { duration: 3000 });
      } finally {
        this.showLoader = false;
        this.cdr.markForCheck();
      }
    }
  }
}
